import { getBaseUrl } from '../../common/getBaseUrl';
import {
  deleteData,
  getBlobData,
  getData,
  postData,
  putData,
} from '../../common/getData';
import { createHeaders } from '../../common/lib/createHeaders';
import { ApiResponse } from '../../types/ApiResponse';
import { BlobApiResponse } from '../../types/BlobApiResponse';
import {
  BostadAutocompleteDto,
  BostadsinformationDto,
  VarderingParametrarDto,
  BostadsvarderingDto,
} from '../types/dtos/VarderingarModel';

const port = '8567';
const path = '/api/vardering/v1';
export const baseUrl = () => getBaseUrl(path, port);

export const getAutocompleteKommun = async (
  searchString: string
): Promise<ApiResponse<string[]>> =>
  getData(
    `${baseUrl()}/autocomplete/kommun?kommun=${searchString}&max-hits=500`,
    createHeaders()
  );

export const getAutocompleteAdress = async (
  selectedKommun: string,
  searchString: string
): Promise<ApiResponse<BostadAutocompleteDto[]>> =>
  getData(
    `${baseUrl()}/autocomplete/adress?kommun=${selectedKommun}&adress=${encodeURIComponent(
      searchString
    )}`,
    createHeaders()
  );

export const getDataFromBostadsregistret = async (
  postort: string,
  adress: string
): Promise<ApiResponse<BostadAutocompleteDto[]>> =>
  getData(
    `${baseUrl()}/autocomplete/bostadsregistret?postort=${postort}&adress=${adress}`,
    createHeaders()
  );

export const getCoordinatesForAdress = async (
  postort: string,
  adress: string
): Promise<ApiResponse<BostadsinformationDto>> =>
  getData(
    `${baseUrl()}/autocomplete/coordinates?postort=${postort}&adress=${adress}`,
    createHeaders()
  );

export const getBostadFromBostadsregistret = async (
  id: number
): Promise<ApiResponse<BostadsinformationDto>> =>
  getData(`${baseUrl()}/autocomplete/bostadsregistret/${id}`, createHeaders());

export const createVardering = async (
  varderingsParametrar: VarderingParametrarDto,
  kundmarke?: string
): Promise<ApiResponse<BostadsvarderingDto>> =>
  postData(
    `${baseUrl()}/varderingar`,
    varderingsParametrar,
    createHeaders(undefined, kundmarke)
  );

export const createOmvardering = async (
  id: string,
  varderingsParametrar: VarderingParametrarDto,
  kundmarke?: string
): Promise<ApiResponse<BostadsvarderingDto>> =>
  putData(
    `${baseUrl()}/varderingar/${id}`,
    varderingsParametrar,
    createHeaders(undefined, kundmarke)
  );

export const getVardering = async (
  uuid: string
): Promise<ApiResponse<BostadsvarderingDto>> =>
  getData(`${baseUrl()}/varderingar/${uuid}`, createHeaders());

export const getAllVarderingar = async (): Promise<
  ApiResponse<BostadsvarderingDto[]>
> => getData(`${baseUrl()}/varderingar`, createHeaders());

export const updateVardering = async (
  uuid: string,
  varderingsParametrar: VarderingParametrarDto
): Promise<ApiResponse<BostadsvarderingDto>> =>
  putData(
    `${baseUrl()}/varderingar/${uuid}`,
    varderingsParametrar,
    createHeaders()
  );

export const deleteVardering = async (uuid: string): Promise<ApiResponse> =>
  deleteData(`${baseUrl()}/varderingar/${uuid}`, undefined, createHeaders());

export const deleteVarderings = async (
  uuids: string[]
): Promise<ApiResponse<BostadsvarderingDto[]>> =>
  deleteData(`${baseUrl()}/varderingar`, uuids, createHeaders());

export const getVarderingsPdf = async (
  uuid: string
): Promise<BlobApiResponse> =>
  getBlobData(`${baseUrl()}/varderingar/${uuid}/pdf`, createHeaders());

export const getKartaForVarderingar = (
  uuid: string
): Promise<BlobApiResponse> =>
  getBlobData(`${baseUrl()}/varderingar/${uuid}/karta`, createHeaders());

export const getPdfForVardering = (uuid: string): Promise<BlobApiResponse> =>
  getBlobData(
    `${baseUrl()}/varderingar/${uuid}/pdf`,
    createHeaders('application/pdf')
  );
